<template>
  <img :class="grayscale" class="notification-type-icon" :src="iconUrl" />
</template>

<script>
import './user-notifications.scss'

export default {
  name: "notification-type-icon.vue",
  props: ['notificationType', 'grayscale'],
  computed: {
    iconUrl () {
      if(!this.notificationType){
        return `/images/notifications/order.svg`;
      }
      return `/images/notifications/${this.notificationType}.svg`
    }
  }
};
</script>
